// src/rds_ui/api/generationApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why). Return
// shapes and thrown error messages are preserved for existing callers.
import { api } from "../../api/client";

const BASE = "/rds";

// ── Config ────────────────────────────────────────────────────────────────────

export async function fetchMethodologies() {
  try {
    const res = await api.get(`${BASE}/config/methodologies`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch methodologies");
  }
}

export async function fetchServiceLines() {
  try {
    const res = await api.get(`${BASE}/config/service-lines`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch service lines");
  }
}

export async function fetchArtifactTypes(methodology, serviceLineCodes) {
  try {
    const params = new URLSearchParams({ methodology });
    for (const code of serviceLineCodes) params.append("service_lines", code);
    const res = await api.get(`${BASE}/config/artifact-types?${params}`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch artifact types");
  }
}

// ── Generation ────────────────────────────────────────────────────────────────

export async function startGeneration(projectId, sowId, { methodology, service_line_codes, artifact_types = null }) {
  try {
    const res = await api.post(`${BASE}/projects/${projectId}/sows/${sowId}/generations`, {
      methodology,
      service_line_codes,
      artifact_types,
    });
    return res.data;
  } catch {
    throw new Error("Failed to start generation");
  }
}

export async function fetchGenerationStatus(runId) {
  try {
    const res = await api.get(`${BASE}/generations/${runId}`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch generation status");
  }
}

export async function fetchProjectGenerations(projectId) {
  try {
    const res = await api.get(`${BASE}/projects/${projectId}/generations`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch generation history");
  }
}

export async function fetchGenerationModules(runId) {
  try {
    const res = await api.get(`${BASE}/generations/${runId}/modules`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch generation modules");
  }
}

export async function cancelGenerationRun(runId) {
  try {
    const res = await api.post(`${BASE}/generations/${runId}/cancel`);
    return res.data;
  } catch {
    throw new Error("Failed to cancel generation run");
  }
}

export async function deleteGenerationRun(runId) {
  try {
    await api.delete(`${BASE}/generations/${runId}`);
  } catch {
    throw new Error("Failed to delete generation run");
  }
}

export async function fetchModuleArtifacts(runId, moduleId, artifactType) {
  try {
    const res = await api.get(`${BASE}/generations/${runId}/modules/${moduleId}/artifacts`, {
      params: artifactType ? { artifact_type: artifactType } : undefined,
    });
    return res.data;
  } catch {
    throw new Error("Failed to fetch artifacts");
  }
}

export async function triggerValidation(runId) {
  try {
    const res = await api.post(`${BASE}/generations/${runId}/validate`);
    return res.data;
  } catch {
    throw new Error("Validation failed to run");
  }
}
